function updateQueryParams(){
    if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }
}
function updateURLParameter(url, param, paramVal){
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (i=0; i<tempArray.length; i++){
            if(tempArray[i].split('=')[0] != param){
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    }
    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
}
function getUrlLastTag(url)
{
    last_tag=0;
    url_array=url.split('+');
    last_tag=url_array[url_array.length-1].split('/')[0].split('?')[0];
    if(!last_tag){
        last_tag=url.split('collections/')[1];
        if(last_tag.split('/').length > 1){
            last_tag=last_tag.split('/')[1].split('?')[0];
        } else{
            last_tag = 0
        }
    }
    return last_tag;
}
function postAjaxJsInit(url,name="",val=""){
    if(name != '[data-show-more]'){
        THEME.loaderCategory ? THEME.loaderCategory.open() : false;
    }else{
        THEME.loaderHorizontalSm ? THEME.loaderHorizontalSm.open() : false;
    }
    updateQueryParams();
    $.get(url, function(data) {
        if(name != '[data-show-more]')
        {
            window.history.pushState('', '', url);
            blocks_to_render = [
                '[data-product-listing]',
                '[data-sidebar]',
                '[data-breadcrumbs]',
                '[data-selected-items]',
                '[data-collection-title]',
                '[data-current-selection]',
                '[data-select-filter--sort]',
                '[data-select-filter--count]',
                '#Huratips-Pagination'
            ]
            blocks_to_replace = [
                '[data-refine-buttons-mobile]'
            ]
            for(block in blocks_to_render)
            {
                if ($(blocks_to_render[block]).length){
                    $(blocks_to_render[block]).html($(blocks_to_render[block], data).html());
                }
            }
            for(block in blocks_to_replace)
            {
                if ($(blocks_to_replace[block]).length){
                    $(blocks_to_replace[block]).replaceWith($(blocks_to_replace[block], data));
                }
            }
            setTimeout(function() {
            if (typeof window.fixSortingLinks === 'function') {
                window.fixSortingLinks();
            }
        }, 1200);
            THEME.catalog.postAjaxCatalog();
        } else {
            $('[data-show-more-wrapper]').remove();
            $('[data-loader-horizontal]').remove();
            $("[data-product-listing]").append(data);
            THEME.product.postAjaxProduct();
            wishlistPage ? wishlistPage.isWishlist() : false;
        }
        currencyUpdate();
        if ($('.js-filter-col-horizontal').length) THEME.initialization.hideEmptyFiltersH('.js-filter-col-horizontal', '.sidebar-block_content', '.filter-toggle');
        if ($('.js-filter-col').length) THEME.initialization.hideEmptyFilters('.js-filter-col', '.sidebar-block_content', '.filter-toggle');
        if(name != '[data-show-more]'){
            THEME.loaderCategory ? THEME.loaderCategory.close() : false;
        }else{
            THEME.loaderHorizontalSm ? THEME.loaderHorizontalSm.close() : false;
        }
    });
}
$(function(){
    Shopify.queryParams = {};
    updateQueryParams();
    if (window.adev_collection_filter_ajax == 1) {
        $(document).on('click','[data-collection-render]',function(e){
            url=$(this).attr('href').replace('#','');
            postAjaxJsInit(url);
            e.preventDefault();
        })

        $(document).on('click','[data-show-more]',function(e){
            url=$(this).attr('href').replace('#','');
            postAjaxJsInit(url,'[data-show-more]');
            e.preventDefault();
        })
    }
})
if (window.adev_collection_filter_ajax == 1) {
$(function(){
    if($('body').hasClass('ie'))
    {
        $('select[name=view]')
                .bind('change', function() {
                            Shopify.queryParams.view = jQuery(this).val();
                            location.search = jQuery.param(Shopify.queryParams);
                        }
                );
    }else
    {
        $(document).on('change','[data-select-filter]',function(e){
            name=$(this).attr('name');
            val=$(this).val();
            url=updateURLParameter(window.location.href.replace('#','').replace('{{ shop.url }}',''), name, val);
            $('.prd-grid-wrap').addClass('is-loading');
            postAjaxJsInit(url,name,val);
            e.preventDefault();
        })
    }
})


} else {
$(function(){
    $('select[name=view]')
            .on('change', function() {
                        Shopify.queryParams.view = jQuery(this).val();
                        location.search = jQuery.param(Shopify.queryParams);
                    }
            );
})
}